import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "popup-header" }
const _hoisted_2 = { class: "popup-header-main" }
const _hoisted_3 = { class: "popup-header-texts" }
const _hoisted_4 = { class: "popup-header-subtitle" }
const _hoisted_5 = { class: "popup-body" }
const _hoisted_6 = { class: "form-group-card" }
const _hoisted_7 = { class: "form-group-content" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = {
  key: 0,
  class: "form-group-card"
}
const _hoisted_10 = { class: "form-group-content" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "form-group-card" }
const _hoisted_13 = { class: "form-group-content" }
const _hoisted_14 = { class: "fg g3" }
const _hoisted_15 = { class: "field span2" }
const _hoisted_16 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "field span3" }
const _hoisted_22 = { class: "field span3" }
const _hoisted_23 = {
  key: 0,
  class: "field span3 field-switch"
}
const _hoisted_24 = { class: "field span3 field-checkbox-group" }
const _hoisted_25 = { class: "checkbox-row" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "popup-body-modern" }
const _hoisted_28 = {
  class: "show-more-container",
  style: {"display":"flex","justify-content":"center","margin":"1px 0"}
}
const _hoisted_29 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_30 = { class: "form-footer footer-modern" }
const _hoisted_31 = {
  class: "footer-right",
  style: {"margin-top":"1px","text-align":"right"}
}
const _hoisted_32 = { class: "popup-body-modern" }
const _hoisted_33 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_34 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_35 = {
  class: "footer-right",
  style: {"margin-top":"10px","text-align":"right"}
}

import { ref, shallowRef, computed, watch, onMounted } from 'vue';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import DxSwitch from 'devextreme-vue/switch';
import DxCheckBox from 'devextreme-vue/check-box';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxForm, { DxItem as DxFormItem } from 'devextreme-vue/form';
import { DxRequiredRule } from 'devextreme-vue/validator';
import DxDataGrid, {
    DxFilterRow,
    DxPaging,
    DxScrolling,
    DxSearchPanel,
    DxSelection,
    DxToolbar as DxGridToolbar,
    DxItem as DxGridToolbarItem,
} from 'devextreme-vue/data-grid';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import ProComenziService from '@/services/Comercial/ProComenzi';
import PAR_Parteneri from '@/services/PAR/PAR_Parteneri';
import JwtServices from '@/services/JwtServices';
import AnafService from '@/services/AnafService';
import { useAddPartener } from '@/composable/useAddPartener';

interface Category {
    TipComanda: number;
    Denumire: string;
    TipFurnizor?: boolean | null;
    ValutaID?: string | null;
    AreContract?: boolean | null;
}

interface Props {
    visible: boolean;
    tipComanda?: number | null;
    comandaId?: string;
}

const ROMANIA_TARA_ID = 'd31c3594-8d39-4355-9a13-fd699a1b7290';
// "Romania" (fără diacritice) — corespunde exact valorii din ERP_Tari.Nume, ca să nu difere
// de textul pe care l-ar pune onTaraSelectionChanged la o reselectare manuală.
const ROMANIA_NUME = 'Romania';

const GRUP_PERSOANA_FIZICA_ID = 'd41f9383-09b5-42c7-a33c-5050a438752a';
const GRUP_SMB_ID = '646a5caa-f34a-43ee-aebb-f1509b3e005e';


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupAdaugareDetaliu',
  props: {
    visible: { type: Boolean },
    tipComanda: {},
    comandaId: {}
  },
  emits: ["update:visible", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const selectedTipComandaLocal = ref<number | null>(null);
const categoriesArray = ref<Category[]>([]);
const dsValute = ref<DataSource | null>(null);
const dsClienti = ref<DataSource | null>(null);
const dsAgenti = ref<DataSource | null>(null);
const dsContracte = ref<DataSource | null>(null);

const headerClientId = ref<string | null>(null);
const clientGridRef = ref<any>(null);
const isPartenerDropDownOpened = ref(false);
const headerAgentId = ref<string | null>(null);
const headerDataComenzii = ref<Date>(new Date());
const headerValutaId = ref<string | null>(null);
const headerTermenLivrare = ref<Date | null>(null);
const headerNume = ref<string>('');
const headerObservatii = ref<string>('');
const headerContractId = ref<string | null>(null);
const headerLivrareDirectaFurnizor = ref(false);
const headerExpCurierNume = ref<string>('');
const isSaving = ref(false);
const { idempotencyKey: comandaIdempotencyKey, resetIdempotencyKey: resetComandaIdempotencyKey } = useAddPartener();

const EXP_CURIER_OPTIONS = ['CURIER', 'SOFER', 'FURNIZOR', 'SEDIU', 'TEHNICIENI'];
const EXP_CURIER_LABELS: Record<string, string> = { SEDIU: 'RIDICARE DE LA SEDIU', TEHNICIENI: 'RIDICĂ TEHNICIENII' };

// Cele 4 bife se exclud reciproc — sursa unică de adevăr e chiar valoarea câmpului "Curier Nume"
// (fiecare bifă e "activă" doar dacă textul e egal cu eticheta ei); bifarea completează automat
// câmpul, dar acesta rămâne liber editabil ulterior (ex. numele exact al firmei de curierat).
function onToggleExpCurierTip(opt: string, checked: boolean) {
    const label = EXP_CURIER_LABELS[opt] || opt;
    if (checked) {
        headerExpCurierNume.value = label;
    } else if (headerExpCurierNume.value === label) {
        headerExpCurierNume.value = '';
    }
}

// ── Adăugare partener nou (dropdown + popup "Adaugă Partener") ──
const { isSubmitting: isSubmittingPartner, idempotencyKey: partnerIdempotencyKey, resetIdempotencyKey: resetPartnerIdempotencyKey } = useAddPartener();

const isPartnerModalVisible = ref(false);
const showExtendedDetails = ref(false);
const dsParteneriFiscal = ref<ODataStore | null>(null);
const dsBanci = ref<DataSource | null>(null);
const dsGrupuri = ref<DataSource | null>(null);
const dsZona = ref<DataSource | null>(null);
const dsTari = shallowRef<DataSource | null>(null);
const dsCTari = shallowRef<DataSource | null>(null);
const dsTariStore = ref<ODataStore | null>(null);
const dsCTariStore = ref<ODataStore | null>(null);
const dsGrupuriStore = ref<ODataStore | null>(null);
const dsJudete = shallowRef<DataSource | null>(null);
const dsCJudete = shallowRef<DataSource | null>(null);
const dsValutaPartener = ref<ODataStore | null>(null);
const valutaPartenerSelectat = ref<any[]>([]);
const sBanci = ref<string | null>(null);
const sValutaPartener = ref<string | null>(null);
const canEditLimiteCredit = ref(false);
const sTaraID = ref<string | null>(null);
const sCTaraID = ref<string | null>(null);
const isTaraDropDownOpened = ref(false);
const isCTaraDropDownOpened = ref(false);

function createEmptyPartnerData(): Record<string, any> {
    return {
        Nume: '', CUI: '', Cod: '', Fiscal: '', Numar: '', Strada: '', Localitate: '',
        JudetID: null, TaraID: null, ZonaID: null, Cont: '', Banca: '', Litigiu: false,
        Extern: false, Intern: true, Observatii: '', AdaosPret: null, faraScadenta: false,
        ValutaID: '0a61647e-7391-4087-bc01-8eb9c2cededd', Director: '', Fax: '', Tel: '',
        Email: '', www: '', GrupID: null, CP: '', CStrada: '', CLocalitate: '', CJudetID: null,
        CTaraID: null, CCP: '', Bloc: '', CBloc: '', Numarstrada: '', Scarabloc: '',
        CNumarstrada: '', CScarabloc: '', Scadenta: 0, AgentID: null, Angajat: false,
        Memo: '', CreditLimita: -1, DirectorEconomic: '', PersoanaContact: '',
        AplicaTVAlaIncasare: false, CifraAfacere: null, NrAngajati: null, Activ: true,
        Client: true, Furnizor: true, Owner: '', CalculezPenalitati: true,
        ParRecomandareID: null, CapitalSocial: null, AngajatID: null, ExternUE: false,
        StructuraLegaturaID: null, PartenerMasterID: null, RegimSpecialTVA: false,
        AplicaTvaDefalcat: false, Et: '', Ap: '', Adresa: '', CEt: '', CAp: '', CAdresa: '',
        CalculezPenalitatiDeLa: null, Prefix: '', Sufix: '', Caen: '', PunctID: null, ParentID: null,
    };
}

const newPartnerData = ref<Record<string, any>>(createEmptyPartnerData());

const isBankModalVisible = ref(false);
const dsValuteBanca = ref<DataSource | null>(null);
const sValute = ref<string | null>(null);
const newBankData = ref<Record<string, any>>({
    PartenerId: null, Cod: null, Nume: null, CodIban: null, CodBic: null,
    Principala: null, CodSwift: null, ValutaId: '0a61647e-7391-4087-bc01-8eb9c2cededd',
    Ordine: null, Activ: null, TextFc: null,
});

const cuiOptions = computed(() => ({
    placeholder: 'Introdu CUI',
    valueChangeEvent: 'keyup',
    onValueChanged: (e: any) => { newPartnerData.value.Cod = e.value; },
    onEnterKey: () => onSearchAnaf(),
    buttons: [{
        name: 'searchAnaf',
        location: 'after',
        options: {
            icon: 'search', width: 26, height: 26, type: 'default',
            hint: 'Caută în ANAF',
            onClick: () => onSearchAnaf(),
        },
    }],
}));

const tipComandaDenumire = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return '';
    return categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value)?.Denumire ?? '';
});

const partenerLabel = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return 'Partener';
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.TipFurnizor === true ? 'Furnizor' : 'Client';
});

const areContractRequired = computed<boolean>(() => {
    if (selectedTipComandaLocal.value == null) return false;
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.AreContract === true;
});

function initDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    ProComenziService.getCategoriiPermise().then((resp: any) => {
        categoriesArray.value = (resp.data ?? []) as Category[];
    });
    dsContracte.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Numar', 'Denumire'],
        sort: [{ selector: 'Numar', desc: false }],
    });
    dsValute.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Simbol'],
        sort: [{ selector: 'Simbol', desc: false }],
    });
    dsAgenti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function buildDsClienti(tipFurnizor: boolean | null | undefined) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };
    const filtru = tipFurnizor === true ? ['Furnizor', '=', true] : ['Client', '=', true];
    dsClienti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Nume', 'CUI', 'ValutaID'],
        filter: filtru,
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function partenerDisplayExpr(item: any): string {
    if (!item) return '';
    return item.CUI ? `${item.Nume} - ${item.CUI}` : item.Nume;
}

function onPartenerRowClick(e: any) {
    if (!e.data) return;
    headerClientId.value = e.data.ID;
    if (e.data.ValutaID) headerValutaId.value = e.data.ValutaID;
    isPartenerDropDownOpened.value = false;
}

function buildDsJudete(taraId: string | null | undefined) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };
    // Nomenclatorul ERP_Judete conține rânduri istorice fără Nume completat (doar Cod numeric,
    // orfane din import) — filtrate aici ca să nu apară goale în dropdown, fără a atinge datele.
    const filtruNumeCompletat = [['Nume', '<>', null], 'and', ['Nume', '<>', '']];
    const filtru = taraId ? [['TaraID', '=', taraId], 'and', filtruNumeCompletat] : filtruNumeCompletat;
    return new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4, fieldTypes: { TaraID: 'Guid' }, beforeSend: hdr },
        select: ['ID', 'Nume'],
        filter: filtru,
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function initPartnerDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    dsParteneriFiscal.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsBanci.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsGrupuriStore.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsGrupuri.value = new DataSource({
        store: dsGrupuriStore.value,
        select: ['Id', 'Nume', 'Cod'],
        sort: [{ selector: 'Cod', desc: false }],
    });
    dsZona.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsTariStore.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsTari.value = new DataSource({
        store: dsTariStore.value,
        select: ['ID', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
    dsCTariStore.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsCTari.value = new DataSource({
        store: dsCTariStore.value,
        select: ['ID', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
    dsJudete.value = buildDsJudete(newPartnerData.value.TaraID);
    dsCJudete.value = buildDsJudete(newPartnerData.value.CTaraID);
    dsValutaPartener.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsValuteBanca.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Simbol'],
    });
}

// Litere mici — trebuie să corespundă EXACT cu formatul în care .NET serializează Guid-ul
// (System.Guid.ToString() implicit e lowercase), altfel DxDropDownBox respinge intern
// potrivirea (comparație case-sensitive în DevExtreme) deși request-ul byKey reușește (200).
function onAddNewPartener() {
    newPartnerData.value = {
        ...createEmptyPartnerData(),
        Owner: JwtServices.GetUsername(),
        TaraID: ROMANIA_TARA_ID,
        Adresa: ROMANIA_NUME,
    };
    sBanci.value = null;
    sValutaPartener.value = null;
    valutaPartenerSelectat.value = [];
    showExtendedDetails.value = false;
    resetPartnerIdempotencyKey();
    isPartnerModalVisible.value = true;

    dsJudete.value = buildDsJudete(newPartnerData.value.TaraID);
    dsCJudete.value = buildDsJudete(newPartnerData.value.CTaraID);
    sTaraID.value = newPartnerData.value.TaraID;
    sCTaraID.value = newPartnerData.value.CTaraID;
    ultimulJudetInAdresa = null;
    ultimulJudetInCAdresa = null;
    ultimaLocalitateInAdresa = null;
    ultimaCLocalitateInCAdresa = null;
}

// Tine minte ultimul nume de județ adăugat automat în Adresa/CAdresa, ca la schimbarea
// județului să-l putem elimina pe cel vechi înainte să adăugăm noul nume — altfel fiecare
// schimbare de județ se ADAUGĂ la infinit în câmpul de adresă (10 schimbări = 10 județe înșirate).
let ultimulJudetInAdresa: string | null = null;
let ultimulJudetInCAdresa: string | null = null;
let ultimaLocalitateInAdresa: string | null = null;
let ultimaCLocalitateInCAdresa: string | null = null;

function onTaraSelectionChanged(e: any) {
    if (!e.selectedRowKeys?.length) return;
    const id = e.selectedRowKeys[0];
    sTaraID.value = id;
    newPartnerData.value.JudetID = null;
    dsJudete.value = buildDsJudete(id);
    isTaraDropDownOpened.value = false;
    const taraNume = e.selectedRowsData?.[0]?.Nume;
    if (taraNume) newPartnerData.value.Adresa = taraNume;
    ultimulJudetInAdresa = null;
    ultimaLocalitateInAdresa = null;
}

function onCTaraSelectionChanged(e: any) {
    if (!e.selectedRowKeys?.length) return;
    const id = e.selectedRowKeys[0];
    sCTaraID.value = id;
    newPartnerData.value.CJudetID = null;
    dsCJudete.value = buildDsJudete(id);
    isCTaraDropDownOpened.value = false;
    const taraNume = e.selectedRowsData?.[0]?.Nume;
    if (taraNume) newPartnerData.value.CAdresa = taraNume;
    ultimulJudetInCAdresa = null;
    ultimaCLocalitateInCAdresa = null;
}

function aplicaJudetInAdresa(judetNume: string) {
    let current = (newPartnerData.value.Adresa || '').trim();
    if (ultimulJudetInAdresa) {
        current = current.replace(ultimulJudetInAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.Adresa = current ? `${current}, ${judetNume}` : judetNume;
    ultimulJudetInAdresa = judetNume;
}

function onJudetChanged(e: any) {
    const judetNume = e.component.option('selectedItem')?.Nume;
    if (!judetNume) return;
    aplicaJudetInAdresa(judetNume);
}

function aplicaLocalitateInAdresa(localitate: string) {
    let current = (newPartnerData.value.Adresa || '').trim();
    if (ultimaLocalitateInAdresa) {
        current = current.replace(ultimaLocalitateInAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.Adresa = localitate ? (current ? `${current}, ${localitate}` : localitate) : current;
    ultimaLocalitateInAdresa = localitate || null;
}

function onLocalitateChanged(e: any) {
    aplicaLocalitateInAdresa(String(e.value || '').trim());
}

// Normalizare diacritice + case pentru potrivirea numelui de județ primit de la ANAF
// (ex: "BIHOR") cu nomenclatorul ERP_Judete (ex: "Bihor"), fără sensibilitate la
// majuscule/diacritice (ANAF poate reveni cu sau fără diacritice, ex: "MURES"/"MUREȘ").
function normalizeazaText(text: string | null | undefined): string {
    return String(text ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toUpperCase()
        .trim();
}

async function cautaJudetDupaNume(nume: string | null | undefined, taraId: string | null): Promise<{ ID: string; Nume: string } | null> {
    if (!nume || !taraId) return null;
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const store = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4,
        fieldTypes: { TaraID: 'Guid' },
        beforeSend: (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; },
    });
    const rows: any[] = await store.load({ filter: ['TaraID', '=', taraId], select: ['ID', 'Nume'] });
    const target = normalizeazaText(nume);
    return rows.find(j => normalizeazaText(j.Nume) === target) ?? null;
}

function onCJudetChanged(e: any) {
    const judetNume = e.component.option('selectedItem')?.Nume;
    if (!judetNume) return;
    let current = (newPartnerData.value.CAdresa || '').trim();
    if (ultimulJudetInCAdresa) {
        current = current.replace(ultimulJudetInCAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.CAdresa = current ? `${current}, ${judetNume}` : judetNume;
    ultimulJudetInCAdresa = judetNume;
}

function onCLocalitateChanged(e: any) {
    const localitate = String(e.value || '').trim();
    let current = (newPartnerData.value.CAdresa || '').trim();
    if (ultimaCLocalitateInCAdresa) {
        current = current.replace(ultimaCLocalitateInCAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.CAdresa = localitate ? (current ? `${current}, ${localitate}` : localitate) : current;
    ultimaCLocalitateInCAdresa = localitate || null;
}

function onSaveNewPartner() {
    if (!newPartnerData.value.Nume || String(newPartnerData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.Fiscal) {
        notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.TaraID) {
        notify('Completați câmpul obligatoriu "Țara"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.JudetID) {
        notify('Completați câmpul obligatoriu "Județ"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.Localitate || String(newPartnerData.value.Localitate).trim() === '') {
        notify('Completați câmpul obligatoriu "Localitate"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.GrupID) {
        notify('Completați câmpul obligatoriu "Grup"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.ZonaID) {
        notify('Completați câmpul obligatoriu "Zona"!', 'error', 1000);
        return;
    }

    isSubmittingPartner.value = true;
    PAR_Parteneri.save(newPartnerData.value, partnerIdempotencyKey.value).then((response: any) => {
        isSubmittingPartner.value = false;
        isPartnerModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response.data?.ID || response.data?.Id;
        if (newId) {
            headerClientId.value = newId;
            if (response.data.ValutaID) headerValutaId.value = response.data.ValutaID;
        }
        isPartenerDropDownOpened.value = false;
        dsClienti.value?.reload();
    }).catch((error: any) => {
        isSubmittingPartner.value = false;
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (status === 409 && data?.code === 'CUI_EXISTS') {
            notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
            return;
        }
        notify('Eroare la salvarea partenerului.', 'error', 2000);
    });
}

function onBanciRowClick(e: any) {
    if (e.data) {
        sBanci.value = e.data.Id;
        newPartnerData.value.Banca = e.data.Nume;
    } else {
        sBanci.value = null;
        newPartnerData.value.Banca = '';
    }
}

function onAddNewBank() {
    newBankData.value = {
        PartenerId: null, Cod: null, Nume: null, CodIban: null, CodBic: null,
        Principala: null, CodSwift: null, ValutaId: '0a61647e-7391-4087-bc01-8eb9c2cededd',
        Ordine: null, Activ: null, TextFc: null,
    };
    sValute.value = '0a61647e-7391-4087-bc01-8eb9c2cededd';
    isBankModalVisible.value = true;
}

function onSaveNewBank() {
    if (!newBankData.value.Nume || String(newBankData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }

    const savedBankData = { ...newBankData.value };
    PAR_Parteneri.saveBank(newBankData.value).then((response: any) => {
        isBankModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;
        dsBanci.value?.reload().then(() => {
            if (newId) {
                sBanci.value = newId;
                newPartnerData.value.Banca = savedBankData.Nume;
            }
        });
    }).catch(() => {
        notify('Datele există deja sau a apărut o eroare!', 'error', 2000);
    });
}

// Litere mici — același motiv ca la ROMANIA_TARA_ID (comparație case-sensitive în DevExtreme
// față de Guid-ul lowercase serializat de .NET).
function onValutaPartenerSelectionChanged(e: any) {
    if (e.selectedRowKeys?.length > 0) {
        sValutaPartener.value = e.selectedRowKeys[0];
    } else {
        sValutaPartener.value = null;
    }
    newPartnerData.value.ValutaID = sValutaPartener.value;
}

function onValuteRowClick(e: any) {
    if (e.data) {
        sValute.value = e.data.Id;
        newBankData.value.ValutaId = e.data.Id;
    } else {
        sValute.value = null;
    }
}

function handleInternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Extern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternUEChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.Extern = false;
    }
}

async function onSearchAnaf() {
    const cuiRaw = newPartnerData.value.CUI;
    if (!cuiRaw) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    const cui = Number(String(cuiRaw).replace(/\D/g, ''));
    if (!cui) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    try {
        const anafResult = await AnafService.getCompanyDetails(cui);
        if (!anafResult) {
            notify('CUI-ul nu a fost găsit sau nu există date publice.', 'warning', 3000);
            return;
        }

        const dg = anafResult.date_generale;
        const ss = anafResult.adresa_sediu_social;
        const df = anafResult.adresa_domiciliu_fiscal;
        const formaOrg = String(dg?.forma_organizare ?? '').toUpperCase().trim();
        const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

        let fiscal = null;
        if (formaOrg.includes('PERSOANA FIZICA')) {
            fiscal = 'F';
        } else if (formaOrg.includes('PERSOANA JURIDICA')) {
            fiscal = scpTVA ? 'P' : 'N';
        }
        if (fiscal) newPartnerData.value.Fiscal = fiscal;

        // La fel ca în legacy (PAR_ParteneriForm.cs): CUI cu prefix "RO" doar dacă firma e
        // înregistrată ca plătitor de TVA la data căutării, altfel fără prefix.
        newPartnerData.value.CUI = scpTVA ? `RO${dg.cui}` : String(dg.cui);
        newPartnerData.value.Nume = dg.denumire ?? newPartnerData.value.Nume;
        newPartnerData.value.Numar = dg.nrRegCom ?? newPartnerData.value.Numar;
        newPartnerData.value.Caen = dg.cod_CAEN ?? newPartnerData.value.Caen;
        newPartnerData.value.CAdresa = dg.adresa ?? newPartnerData.value.CAdresa;
        newPartnerData.value.Localitate = ss.sdenumire_Localitate ?? newPartnerData.value.Localitate;
        newPartnerData.value.Strada = ss.sdenumire_Strada ?? newPartnerData.value.Strada;
        newPartnerData.value.Numarstrada = ss.snumar_Strada ?? newPartnerData.value.Numarstrada;
        newPartnerData.value.CP = ss.scod_Postal ?? newPartnerData.value.CP;
        newPartnerData.value.Tel = dg.telefon ?? newPartnerData.value.Tel;

        if (dg.iban) newPartnerData.value.Cont = dg.iban;
        newPartnerData.value.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;
        newPartnerData.value.AplicaTvaDefalcat = anafResult.inregistrare_SplitTVA?.statusSplitTVA ?? false;
        if (anafResult.stare_inactiv?.statusInactivi) {
            newPartnerData.value.Activ = false;
            notify('Atenție: firma este marcată ca INACTIVĂ la ANAF!', 'warning', 4000);
        }

        // Județ Sediu Social — ANAF întoarce doar numele (ex: "BIHOR"), nu ID-ul din
        // nomenclatorul intern ERP_Judete; se caută prin nume normalizat (fără diacritice/case).
        if (ss?.sdenumire_Judet) {
            const judet = await cautaJudetDupaNume(ss.sdenumire_Judet, newPartnerData.value.TaraID);
            if (judet) {
                newPartnerData.value.JudetID = judet.ID;
                aplicaJudetInAdresa(judet.Nume);
            } else {
                console.warn(`Județul „${ss.sdenumire_Judet}" (Sediu Social) nu a fost găsit în nomenclator — selectează-l manual.`);
            }
        }
        if (ss?.sdenumire_Localitate) aplicaLocalitateInAdresa(ss.sdenumire_Localitate);

        // Domiciliu Fiscal — completează și câmpurile structurate (CAdresa de mai sus rămâne
        // textul complet trimis direct de ANAF, nu se reconstruiește din bucăți).
        if (df) {
            newPartnerData.value.CLocalitate = df.ddenumire_Localitate ?? newPartnerData.value.CLocalitate;
            newPartnerData.value.CStrada = df.ddenumire_Strada ?? newPartnerData.value.CStrada;
            newPartnerData.value.CNumarstrada = df.dnumar_Strada ?? newPartnerData.value.CNumarstrada;
            newPartnerData.value.CCP = df.dcod_Postal ?? newPartnerData.value.CCP;
            if (df.ddenumire_Judet) {
                if (!newPartnerData.value.CTaraID) {
                    newPartnerData.value.CTaraID = newPartnerData.value.TaraID;
                    sCTaraID.value = newPartnerData.value.CTaraID;
                    dsCJudete.value = buildDsJudete(newPartnerData.value.CTaraID);
                }
                const cJudet = await cautaJudetDupaNume(df.ddenumire_Judet, newPartnerData.value.CTaraID);
                if (cJudet) {
                    newPartnerData.value.CJudetID = cJudet.ID;
                } else {
                    console.warn(`Județul „${df.ddenumire_Judet}" (Domiciliu Fiscal) nu a fost găsit în nomenclator — selectează-l manual.`);
                }
            }
        }

        const extras: string[] = [];
        if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
        if (typeof dg.statusRO_e_Factura === 'boolean') extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? 'DA' : 'NU'}`);

        try {
            let finData = await AnafService.getFinancialData(cui, 2024);
            if (!finData || !finData.i || finData.i.length === 0) {
                finData = await AnafService.getFinancialData(cui, 2023);
            }

            if (finData && finData.i) {
                const indicatori = finData.i;
                const caRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('CIFRA DE AFACERI NET') || nume === 'VENITURI TOTALE';
                });
                const angRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('NUMAR MEDIU DE SALARIATI') || nume.includes('NR. MEDIU SALARIATI');
                });

                if (caRow) {
                    newPartnerData.value.CifraAfacere = caRow.val_indicator;
                    extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                }
                if (angRow) {
                    newPartnerData.value.NrAngajati = angRow.val_indicator;
                    extras.push(`Angajați: ${angRow.val_indicator}`);
                }
            }
        } catch (finError) {
            console.warn('Datele financiare nu au putut fi încărcate.', finError);
        }

        if (extras.length) {
            const prev = newPartnerData.value.Memo ? String(newPartnerData.value.Memo).trim() + '\n' : '';
            newPartnerData.value.Memo = prev + extras.join(' | ');
        }

        notify('Datele au fost preluate cu succes!', 'success', 2000);
    } catch (error) {
        console.error(error);
        notify('Eroare la interogarea ANAF', 'error', 4000);
    }
}

async function loadCurrentAgent() {
    try {
        const res = await ProComenziService.getAgentCurent();
        headerAgentId.value = res.data?.AgentId ?? null;
    } catch {
        headerAgentId.value = null;
    }
}

async function handleSave() {
    isSaving.value = true;
    try {
        const resp = await ProComenziService.creeazaComanda({
            Tipcomanda: selectedTipComandaLocal.value,
            ClientId: headerClientId.value ?? null,
            AgentId: headerAgentId.value ?? null,
            DataComenzii: headerDataComenzii.value,
            ValutaId: headerValutaId.value ?? null,
            TermenLivrare: headerTermenLivrare.value ?? null,
            Nume: headerNume.value || null,
            Observatii: headerObservatii.value || null,
            ContractId: headerContractId.value ?? null,
            LivrareDirectaFurnizor: partenerLabel.value === 'Client' ? headerLivrareDirectaFurnizor.value : false,
            ExpCurierNume: headerExpCurierNume.value || null,
        }, comandaIdempotencyKey.value);
        resetComandaIdempotencyKey();
        emit('saved', resp.data);
        allowNextHide = true;
        emit('update:visible', false);
    } catch (err: any) {
        const raw = err?.response?.data;
        const msg = typeof raw === 'string' ? raw : (err?.message ?? 'Eroare la salvare.');
        notify(msg, 'error', 3000);
    } finally {
        isSaving.value = false;
    }
}

// Snapshot-ul câmpurilor imediat după deschidere (după reset + auto-completarea agentului
// curent) — comparat cu starea curentă la orice încercare de închidere, ca să deosebim
// "formular neatins" (închidere directă) de "userul a completat ceva" (cere confirmare).
// Nu se compară cu valori hardcodate (ex. "Tip Comandă gol") pentru că popup-ul poate porni
// cu tipul deja preselectat (props.tipComanda) sau cu agentul auto-completat — ambele sunt
// stare de deschidere legitimă, nu input de la user.
function currentFormSnapshot() {
    return JSON.stringify({
        tip: selectedTipComandaLocal.value,
        client: headerClientId.value,
        agent: headerAgentId.value,
        data: headerDataComenzii.value,
        valuta: headerValutaId.value,
        termen: headerTermenLivrare.value,
        nume: headerNume.value,
        obs: headerObservatii.value,
        contract: headerContractId.value,
        livrareDirecta: headerLivrareDirectaFurnizor.value,
        curierNume: headerExpCurierNume.value,
    });
}

const initialSnapshot = ref('');
const isFormDirty = computed(() => currentFormSnapshot() !== initialSnapshot.value);

// Setat true chiar înainte de un emit('update:visible', false) deja confirmat (salvare reușită
// sau confirmare explicită în requestClose) — altfel @hiding l-ar intercepta din nou pe
// închiderea provocată de acel emit, cerând confirmare de două ori / la nesfârșit.
let allowNextHide = false;

async function requestClose() {
    if (!isFormDirty.value) {
        allowNextHide = true;
        emit('update:visible', false);
        return;
    }
    const ok = await custom({
        title: 'Renunți la comanda nouă?',
        messageHtml: 'Ai completat date în formular. Dacă închizi acum, informațiile introduse se pierd.',
        buttons: [
            { text: 'Renunț la comandă', type: 'danger', onClick: () => true },
            { text: 'Rămân în formular', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    allowNextHide = true;
    emit('update:visible', false);
}

// Acoperă închiderile care nu trec prin butoanele proprii (× / Anulează) — ex. tasta Escape,
// care închide popup-ul DevExtreme direct, indiferent de close-on-outside-click=false.
function onPopupHiding(e: any) {
    if (allowNextHide) {
        allowNextHide = false;
        return;
    }
    e.cancel = true;
    requestClose();
}

onMounted(() => {
    initDataSources();
    initPartnerDataSources();
    PAR_Parteneri.getDrepturiMele()
        .then((res: any) => { canEditLimiteCredit.value = res.data?.EditareLimiteCredit === true; })
        .catch(() => { canEditLimiteCredit.value = false; });
});

watch(() => newPartnerData.value.Fiscal, (newVal) => {
    if (newVal === 'F') {
        newPartnerData.value.GrupID = GRUP_PERSOANA_FIZICA_ID;
    } else if (newVal === 'P' || newVal === 'N') {
        newPartnerData.value.GrupID = GRUP_SMB_ID;
    }
});

watch(sTaraID, (newId) => {
    newPartnerData.value.TaraID = newId;
});

watch(sCTaraID, (newId) => {
    newPartnerData.value.CTaraID = newId;
});

watch(sValutaPartener, (newId) => {
    if (newId && dsValutaPartener.value) {
        (dsValutaPartener.value as ODataStore).byKey(newId).then((x: any) => {
            x.Simbol = x.Simbol ?? '(fara simbol)';
            valutaPartenerSelectat.value = [x];
        });
    } else {
        valutaPartenerSelectat.value = [];
    }
});

watch(isPartenerDropDownOpened, (isOpened) => {
    if (isOpened) clientGridRef.value?.instance?.clearFilter();
});

watch(selectedTipComandaLocal, (tipComanda) => {
    headerClientId.value = null;
    if (tipComanda == null) {
        dsClienti.value = null;
        headerValutaId.value = null;
        return;
    }
    const cat = categoriesArray.value.find(c => c.TipComanda === tipComanda);
    buildDsClienti(cat?.TipFurnizor);
    headerValutaId.value = cat?.ValutaID ?? null;
});

watch(() => props.visible, async (isVisible) => {
    if (isVisible) {
        selectedTipComandaLocal.value = props.tipComanda ?? null;
        headerClientId.value = null;
        headerDataComenzii.value = new Date();
        headerValutaId.value = null;
        headerTermenLivrare.value = null;
        headerNume.value = '';
        headerObservatii.value = '';
        headerContractId.value = null;
        headerLivrareDirectaFurnizor.value = false;
        headerExpCurierNume.value = '';
        resetComandaIdempotencyKey();
        // Grid-ul de selecție client își păstrează textul din DxSearchPanel ȘI filtrele pe coloane
        // (Nume/CUI din DxFilterRow) — instanța rămâne montată cât timp DxPopup e doar ascuns, fără
        // reset explicit, o căutare/filtrare făcută la o comandă rămânea activă și la următoarea.
        clientGridRef.value?.instance?.clearFilter();
        await loadCurrentAgent();
        initialSnapshot.value = currentFormSnapshot();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DxPopup), {
      visible: __props.visible,
      "show-title": true,
      "drag-enabled": true,
      "resize-enabled": false,
      "show-close-button": false,
      "close-on-outside-click": false,
      width: 680,
      height: 'auto',
      onHiding: onPopupHiding,
      onHidden: _cache[11] || (_cache[11] = ($event: any) => (emit('update:visible', false)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "dx-icon dx-icon-add popup-header-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "popup-header-title" }, "Comandă nouă", -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(tipComandaDenumire.value || 'Selectați tipul comenzii'), 1)
            ])
          ]),
          _createElementVNode("span", {
            class: "header-close",
            onClick: requestClose
          }, "×")
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "form-group-caption" }, [
              _createTextVNode("Tip Comandă "),
              _createElementVNode("span", { class: "required-star" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(DxSelectBox), {
                  value: selectedTipComandaLocal.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedTipComandaLocal).value = $event)),
                  items: categoriesArray.value,
                  "display-expr": "Denumire",
                  "value-expr": "TipComanda",
                  "search-enabled": true,
                  "show-clear-button": true,
                  placeholder: "Selectați tipul comenzii..."
                }, null, 8, ["value", "items"])
              ])
            ])
          ]),
          (areContractRequired.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "form-group-caption" }, [
                  _createTextVNode("Contract "),
                  _createElementVNode("span", { class: "required-star" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(DxSelectBox), {
                      value: headerContractId.value,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((headerContractId).value = $event)),
                      "data-source": dsContracte.value,
                      "display-expr": "Numar",
                      "value-expr": "ID",
                      "search-enabled": true,
                      "show-clear-button": true,
                      placeholder: "Selectați contractul..."
                    }, null, 8, ["value", "data-source"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "form-group-caption" }, "Informații Comandă", -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(partenerLabel.value) + " ", 1),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "required-star" }, "*", -1))
                  ]),
                  _createVNode(_unref(DxDropDownBox), {
                    value: headerClientId.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((headerClientId).value = $event)),
                    opened: isPartenerDropDownOpened.value,
                    "onUpdate:opened": _cache[3] || (_cache[3] = ($event: any) => ((isPartenerDropDownOpened).value = $event)),
                    "data-source": dsClienti.value,
                    "display-expr": partenerDisplayExpr,
                    "value-expr": "ID",
                    "show-clear-button": true,
                    disabled: selectedTipComandaLocal.value == null,
                    placeholder: partenerLabel.value ? 'Selectați ' + partenerLabel.value.toLowerCase() + '...' : 'Selectați tipul comenzii mai întâi...',
                    "content-template": "gridContent",
                    "drop-down-options": { width: 500, height: 400 }
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(DxDataGrid), {
                          ref_key: "clientGridRef",
                          ref: clientGridRef,
                          "data-source": dsClienti.value,
                          columns: ['Nume', 'CUI'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: onPartenerRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DxScrolling), { mode: "virtual" }),
                            _createVNode(_unref(DxFilterRow), { visible: true }),
                            _createVNode(_unref(DxPaging), {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_unref(DxSearchPanel), {
                              visible: true,
                              placeholder: "Caută..."
                            }),
                            _createVNode(_unref(DxGridToolbar), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DxGridToolbarItem), { location: "after" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(DxButton), {
                                      icon: "plus",
                                      type: "success",
                                      height: "25px",
                                      width: "25px",
                                      onClick: onAddNewPartener
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(DxGridToolbarItem), { name: "searchPanel" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "opened", "data-source", "disabled", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", null, [
                    _createTextVNode("Agent "),
                    _createElementVNode("span", { class: "required-star" }, "*")
                  ], -1)),
                  _createVNode(_unref(DxSelectBox), {
                    value: headerAgentId.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((headerAgentId).value = $event)),
                    "data-source": dsAgenti.value,
                    "display-expr": "Nume",
                    "value-expr": "Id",
                    "search-enabled": true,
                    "search-expr": "Nume",
                    "show-clear-button": true,
                    placeholder: "Selectați agentul..."
                  }, null, 8, ["value", "data-source"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", null, "Data Comenzii", -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: headerDataComenzii.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((headerDataComenzii).value = $event)),
                    "display-format": "dd.MM.yyyy",
                    "show-clear-button": false
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", null, "Valută", -1)),
                  _createVNode(_unref(DxSelectBox), {
                    value: headerValutaId.value,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((headerValutaId).value = $event)),
                    "data-source": dsValute.value,
                    "display-expr": "Simbol",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "Selectați valuta..."
                  }, null, 8, ["value", "data-source"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", null, "Termen Livrare", -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: headerTermenLivrare.value,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((headerTermenLivrare).value = $event)),
                    "display-format": "dd.MM.yyyy",
                    "show-clear-button": true
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", null, "Denumire", -1)),
                  _createVNode(_unref(DxTextBox), {
                    value: headerNume.value,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((headerNume).value = $event)),
                    "show-clear-button": true,
                    placeholder: "Denumirea comenzii..."
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", null, "Observații", -1)),
                  _createVNode(_unref(DxTextBox), {
                    value: headerObservatii.value,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((headerObservatii).value = $event)),
                    "show-clear-button": true,
                    placeholder: "Observații comandă..."
                  }, null, 8, ["value"])
                ]),
                (partenerLabel.value === 'Client')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_unref(DxSwitch), {
                        value: headerLivrareDirectaFurnizor.value,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((headerLivrareDirectaFurnizor).value = $event))
                      }, null, 8, ["value"]),
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "switch-label" }, [
                        _createTextVNode(" Livrare directă de la furnizor "),
                        _createElementVNode("span", { class: "switch-hint" }, "Furnizorul livrează marfa direct la client, fără să treacă prin gestiunea proprie — comanda poate fi pusă în lucru și facturată fără rezervare de stoc.")
                      ], -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", null, [
                    _createTextVNode("Livrat de "),
                    _createElementVNode("span", { class: "required-star" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(EXP_CURIER_OPTIONS, (opt) => {
                      return _createElementVNode("div", {
                        key: opt,
                        class: _normalizeClass(["checkbox-item", { 'checkbox-item--active': headerExpCurierNume.value === (EXP_CURIER_LABELS[opt] || opt) }]),
                        onClick: ($event: any) => (onToggleExpCurierTip(opt, headerExpCurierNume.value !== (EXP_CURIER_LABELS[opt] || opt)))
                      }, [
                        _createVNode(_unref(DxCheckBox), {
                          class: "checkbox-item-box",
                          value: headerExpCurierNume.value === (EXP_CURIER_LABELS[opt] || opt)
                        }, null, 8, ["value"]),
                        _createElementVNode("span", null, _toDisplayString(EXP_CURIER_LABELS[opt] || opt), 1)
                      ], 10, _hoisted_26)
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: isSaving.value ? 'Se salvează...' : 'Salvează și deschide', type: 'default', disabled: isSaving.value || selectedTipComandaLocal.value == null || !headerClientId.value || !headerAgentId.value || !headerExpCurierNume.value || (areContractRequired.value && !headerContractId.value), onClick: handleSave }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: 'Anulează', stylingMode: 'outlined', onClick: requestClose }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(DxPopup), {
      visible: isPartnerModalVisible.value,
      width: 1450,
      height: 684,
      "show-title": true,
      title: "Adăugare Partener Nou",
      onHiding: _cache[22] || (_cache[22] = ($event: any) => (isPartnerModalVisible.value = false))
    }, {
      title: _withCtx(() => [...(_cache[40] || (_cache[40] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare partener"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile partenerului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_unref(DxForm), {
            "form-data": newPartnerData.value,
            "col-count": 3,
            "col-span": 3
          }, {
            taraTemplate: _withCtx(() => [
              _createVNode(_unref(DxDropDownBox), {
                value: sTaraID.value,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((sTaraID).value = $event)),
                opened: isTaraDropDownOpened.value,
                "onUpdate:opened": _cache[14] || (_cache[14] = ($event: any) => ((isTaraDropDownOpened).value = $event)),
                "data-source": dsTari.value,
                "display-expr": "Nume",
                "value-expr": "ID",
                "show-clear-button": true,
                placeholder: "Selectează țara"
              }, {
                content: _withCtx(() => [
                  _createVNode(_unref(DxDataGrid), {
                    "data-source": dsTari.value,
                    "selected-row-keys": sTaraID.value ? [sTaraID.value] : [],
                    columns: ['Nume'],
                    "hover-state-enabled": true,
                    height: "100%",
                    "remote-operations": true,
                    onSelectionChanged: onTaraSelectionChanged
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxSelection), { mode: "single" }),
                      _createVNode(_unref(DxFilterRow), { visible: true }),
                      _createVNode(_unref(DxScrolling), { mode: "virtual" })
                    ]),
                    _: 1
                  }, 8, ["data-source", "selected-row-keys"])
                ]),
                _: 1
              }, 8, ["value", "opened", "data-source"])
            ]),
            judetTemplate: _withCtx(() => [
              _createVNode(_unref(DxSelectBox), {
                value: newPartnerData.value.JudetID,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((newPartnerData.value.JudetID) = $event)),
                "data-source": dsJudete.value,
                "display-expr": "Nume",
                "value-expr": "ID",
                placeholder: "Selectează județul",
                "search-enabled": true,
                "show-clear-button": true,
                onValueChanged: onJudetChanged
              }, null, 8, ["value", "data-source"])
            ]),
            cTaraTemplate: _withCtx(() => [
              _createVNode(_unref(DxDropDownBox), {
                value: sCTaraID.value,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((sCTaraID).value = $event)),
                opened: isCTaraDropDownOpened.value,
                "onUpdate:opened": _cache[17] || (_cache[17] = ($event: any) => ((isCTaraDropDownOpened).value = $event)),
                "data-source": dsCTari.value,
                "display-expr": "Nume",
                "value-expr": "ID",
                "show-clear-button": true,
                placeholder: "Selectează țara"
              }, {
                content: _withCtx(() => [
                  _createVNode(_unref(DxDataGrid), {
                    "data-source": dsCTari.value,
                    "selected-row-keys": sCTaraID.value ? [sCTaraID.value] : [],
                    columns: ['Nume'],
                    "hover-state-enabled": true,
                    height: "100%",
                    "remote-operations": true,
                    onSelectionChanged: onCTaraSelectionChanged
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxSelection), { mode: "single" }),
                      _createVNode(_unref(DxFilterRow), { visible: true }),
                      _createVNode(_unref(DxScrolling), { mode: "virtual" })
                    ]),
                    _: 1
                  }, 8, ["data-source", "selected-row-keys"])
                ]),
                _: 1
              }, 8, ["value", "opened", "data-source"])
            ]),
            cJudetTemplate: _withCtx(() => [
              _createVNode(_unref(DxSelectBox), {
                value: newPartnerData.value.CJudetID,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((newPartnerData.value.CJudetID) = $event)),
                "data-source": dsCJudete.value,
                "display-expr": "Nume",
                "value-expr": "ID",
                placeholder: "Selectează județul",
                "search-enabled": true,
                "show-clear-button": true,
                onValueChanged: onCJudetChanged
              }, null, 8, ["value", "data-source"])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Identitate & Fiscal",
                "col-count": 6,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CUI",
                    label: { text: 'CUI/CNP' },
                    "editor-options": cuiOptions.value,
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'CUI/CNP' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Nume",
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'Nume' este obligatoriu" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Fiscal",
                    "editor-type": "dxSelectBox",
                    "col-span": 4,
                    label: { text: 'Tip Fiscal' },
                    "editor-options": {
                            dataSource: dsParteneriFiscal.value,
                            displayExpr: 'Nume',
                            valueExpr: 'Cod',
                            placeholder: 'Selectează Tip Fiscal',
                            searchEnabled: true,
                        }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'Tip Fiscal' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Numar",
                    label: { text: 'Regim Comerț' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Caen",
                    label: { text: 'Cod CAEN' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Owner",
                    "editor-options": { readOnly: true },
                    label: { text: 'Responsabil' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Cont",
                    label: { text: 'IBAN' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "GrupID",
                    "editor-type": "dxSelectBox",
                    "col-span": 3,
                    label: { text: 'Grup *' },
                    "editor-options": {
                            dataSource: dsGrupuri.value,
                            displayExpr: 'Nume',
                            valueExpr: 'Id',
                            placeholder: 'Selectează grup',
                            searchEnabled: true,
                            showClearButton: true,
                        }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "ZonaID",
                    "editor-type": "dxSelectBox",
                    "col-span": 3,
                    label: { text: 'Zona *' },
                    "editor-options": {
                            dataSource: dsZona.value,
                            displayExpr: 'Nume',
                            valueExpr: 'Id',
                            placeholder: 'Selectează zonă',
                            searchEnabled: true,
                            showClearButton: true,
                        }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Memo",
                    "col-span": 6,
                    "editor-options": { height: 80 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Sediu Social",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Strada",
                    "col-span": 3
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Numarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Bloc",
                    "col-span": 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Scarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Et",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Ap",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "TaraID",
                    template: "taraTemplate",
                    "col-span": 2,
                    label: { text: 'Țara *' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "JudetID",
                    template: "judetTemplate",
                    "col-span": 2,
                    label: { text: 'Județ *' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Localitate",
                    "col-span": 3,
                    label: { text: 'Localitate' },
                    "editor-options": { onValueChanged: onLocalitateChanged }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'Localitate' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Adresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Domiciliu Fiscal",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CStrada",
                    "col-span": 3,
                    label: { text: 'Strada' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CNumarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CBloc",
                    "col-span": 1,
                    label: { text: 'Bl.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CScarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CEt",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CAp",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CTaraID",
                    template: "cTaraTemplate",
                    "col-span": 2,
                    label: { text: 'Țara' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CJudetID",
                    template: "cJudetTemplate",
                    "col-span": 2,
                    label: { text: 'Județ' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CLocalitate",
                    "col-span": 3,
                    label: { text: 'Localitate' },
                    "editor-options": { onValueChanged: onCLocalitateChanged }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CCP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CAdresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "col-count": 3,
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_unref(DxButton), {
                      "element-attr": { class: 'show-more-btn' },
                      text: showExtendedDetails.value ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare',
                      icon: showExtendedDetails.value ? 'chevronup' : 'chevrondown',
                      type: "normal",
                      "styling-mode": "text",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (showExtendedDetails.value = !showExtendedDetails.value))
                    }, null, 8, ["text", "icon"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_unref(DxForm), {
              "form-data": newPartnerData.value,
              "col-count": 3,
              "col-span": 3
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxFormItem), {
                  "item-type": "group",
                  caption: "Configurare Financiară & Comercială",
                  "css-class": "form-section-simple form-section-card",
                  "col-count": 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DxFormItem), { label: { text: 'Bancă (Internă)' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DxDropDownBox), {
                          value: sBanci.value,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((sBanci).value = $event)),
                          "data-source": dsBanci.value,
                          "display-expr": "Nume",
                          "value-expr": "Id",
                          "show-clear-button": true,
                          placeholder: "Selectează bancă",
                          "content-template": "gridContent",
                          "drop-down-options": { width: 200 }
                        }, {
                          gridContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_unref(DxDataGrid), {
                                "data-source": dsBanci.value,
                                columns: ['Nume'],
                                "hover-state-enabled": true,
                                height: 280,
                                "remote-operations": true,
                                onRowClick: onBanciRowClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(DxPaging), {
                                    enabled: true,
                                    "page-size": 5
                                  }),
                                  _createVNode(_unref(DxFilterRow), { visible: true }),
                                  _createVNode(_unref(DxScrolling), { mode: "virtual" }),
                                  _createVNode(_unref(DxGridToolbar), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(DxGridToolbarItem), { location: "after" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(DxButton), {
                                            icon: "plus",
                                            type: "success",
                                            height: "25px",
                                            width: "25px",
                                            onClick: onAddNewBank
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(DxGridToolbarItem), { name: "searchPanel" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data-source"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["value", "data-source"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(DxFormItem), { label: { text: 'Valută' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DxDropDownBox), {
                          value: sValutaPartener.value,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((sValutaPartener).value = $event)),
                          "data-source": valutaPartenerSelectat.value,
                          "show-clear-button": true,
                          "display-expr": "Simbol",
                          "value-expr": "Id",
                          placeholder: "RON"
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_unref(DxDataGrid), {
                              "data-source": dsValutaPartener.value,
                              "selected-row-keys": sValutaPartener.value ? [sValutaPartener.value] : [],
                              columns: ['Simbol'],
                              "hover-state-enabled": true,
                              height: "100%",
                              onSelectionChanged: onValutaPartenerSelectionChanged
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DxSelection), { mode: "single" }),
                                _createVNode(_unref(DxPaging), {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_unref(DxFilterRow), { visible: true })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys"])
                          ]),
                          _: 1
                        }, 8, ["value", "data-source"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(DxFormItem), { "data-field": "CapitalSocial" }),
                    _createVNode(_unref(DxFormItem), { "data-field": "CifraAfacere" }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "NrAngajati",
                      label: { text: 'Nr. Angajati' }
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "AdaosPret",
                      "col-span": 1
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Scadenta",
                      label: { text: 'Termen de plată' },
                      "col-span": 1,
                      "editor-options": { readOnly: !canEditLimiteCredit.value }
                    }, null, 8, ["editor-options"]),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "CreditLimita",
                      label: { text: 'Limita de credit' },
                      "col-span": 1,
                      "editor-options": { readOnly: !canEditLimiteCredit.value }
                    }, null, 8, ["editor-options"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxFormItem), {
                  "item-type": "group",
                  caption: "Contacte & Diverse",
                  "css-class": "form-section-simple form-section-card",
                  "col-count": 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Tel",
                      label: { text: 'Telefon' }
                    }),
                    _createVNode(_unref(DxFormItem), { "data-field": "Fax" }),
                    _createVNode(_unref(DxFormItem), { "data-field": "Email" }),
                    _createVNode(_unref(DxFormItem), { "data-field": "Director" }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "www",
                      label: { text: 'Www' },
                      "col-span": 2
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Observatii",
                      "col-span": 2,
                      "editor-options": { height: 100 },
                      "editor-type": "dxTextArea"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxFormItem), {
                  "item-type": "group",
                  caption: "System Flags",
                  "css-class": "form-section-simple form-section-card",
                  "col-count": 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "AplicaTVAlaIncasare",
                      "editor-type": "dxCheckBox",
                      label: { text: 'TVA la Încasare' }
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "RegimSpecialTVA",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Intern",
                      "editor-type": "dxCheckBox",
                      "editor-options": { onValueChanged: handleInternChange }
                    }, null, 8, ["editor-options"]),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Extern",
                      "editor-type": "dxCheckBox",
                      label: { text: 'Extern Non UE' },
                      "editor-options": { onValueChanged: handleExternChange }
                    }, null, 8, ["editor-options"]),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "ExternUE",
                      "editor-type": "dxCheckBox",
                      label: { text: 'Extern UE' },
                      "editor-options": { onValueChanged: handleExternUEChange }
                    }, null, 8, ["editor-options"]),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Client",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Furnizor",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Angajat",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Activ",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "AplicaTvaDefalcat",
                      "editor-type": "dxCheckBox",
                      label: { text: 'Split TVA' }
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "faraScadenta",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "CalculezPenalitati",
                      "editor-type": "dxCheckBox"
                    }),
                    _createVNode(_unref(DxFormItem), {
                      "data-field": "Litigiu",
                      "editor-type": "dxCheckBox"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["form-data"])
          ], 512), [
            [_vShow, showExtendedDetails.value]
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_unref(DxButton), {
                text: "Salvează Compania",
                type: "success",
                onClick: onSaveNewPartner,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined",
                disabled: _unref(isSubmittingPartner)
              }, null, 8, ["disabled"]),
              _createVNode(_unref(DxButton), {
                text: "Închide",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (isPartnerModalVisible.value = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(DxPopup), {
      visible: isBankModalVisible.value,
      width: 800,
      height: 550,
      "show-title": true,
      title: "Adăugare Bancă",
      onHiding: _cache[25] || (_cache[25] = ($event: any) => (isBankModalVisible.value = false))
    }, {
      title: _withCtx(() => [...(_cache[41] || (_cache[41] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare bancă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile băncii ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_unref(DxForm), {
            "form-data": newBankData.value,
            "col-count": 2,
            "col-span": 2
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxFormItem), { "data-field": "Ordine" }),
              _createVNode(_unref(DxFormItem), { "data-field": "Cod" }),
              _createVNode(_unref(DxFormItem), { "data-field": "Nume" }),
              _createVNode(_unref(DxFormItem), { label: { text: 'Valută' } }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxDropDownBox), {
                    value: sValute.value,
                    "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((sValute).value = $event)),
                    "data-source": dsValuteBanca.value,
                    "display-expr": "Simbol",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "RON",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": dsValuteBanca.value,
                          columns: ['Simbol'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: onValuteRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DxPaging), {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_unref(DxFilterRow), { visible: true }),
                            _createVNode(_unref(DxScrolling), { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), { "data-field": "CodIban" }),
              _createVNode(_unref(DxFormItem), { "data-field": "CodBic" }),
              _createVNode(_unref(DxFormItem), { "data-field": "CodSwift" }),
              _createVNode(_unref(DxFormItem), { "data-field": "TextFc" }),
              _createVNode(_unref(DxFormItem), {
                "data-field": "Principala",
                "editor-type": "dxCheckBox"
              }),
              _createVNode(_unref(DxFormItem), {
                "data-field": "Activ",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_unref(DxButton), {
                text: "Salvează Banca",
                type: "success",
                onClick: onSaveNewBank,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }),
              _createVNode(_unref(DxButton), {
                text: "Închide",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (isBankModalVisible.value = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})